import TH_Document from '_tradeholding/js/Classes/Document';

import '_premierworld/scss/global.scss';
import jQuery from 'jquery';
import Init from './Initer';
import config from '_config';
import Translate from '_loaders/Translate';

let DocumentObj = new TH_Document();


window.FontAwesomeConfig = { autoReplaceSvg: false };
DocumentObj.addReadyStart(function() {
    let dataDom = jQuery("th-data"),
        language = dataDom.data('language');

    if (language !== null) jQuery.extend(true, config.language, language);

    config.languageCode = config.language.LanguageCode;
    config.node = dataDom.data('node');
	config.inited = true;
    
    Translate.initialized = Translate.init().then(function() {
        Translate.initialized = true;
    });

    Init.all();
});


export default DocumentObj;